import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import Login from './components/Login';
import GameMenu from './components/GameMenu';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [studentId, setStudentId] = useState(null);
  const [token, setToken] = useState(null);

  useEffect(() => {
    // Check if user is already logged in
    const savedToken = localStorage.getItem('token');
    const savedStudentId = localStorage.getItem('studentId');
    if (savedToken && savedStudentId) {
      setToken(savedToken);
      setStudentId(savedStudentId);
      setIsLoggedIn(true);
    }
  }, []);

  const handleLogin = (token, studentId) => {
    setToken(token);
    setStudentId(studentId);
    setIsLoggedIn(true);
    localStorage.setItem('token', token);
    localStorage.setItem('studentId', studentId);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setToken(null);
    setStudentId(null);
    localStorage.removeItem('token');
    localStorage.removeItem('studentId');
  };

  return (
    <div className="App">
      <Header />
      <div className="app-content">
        {!isLoggedIn ? (
          <Login onLogin={handleLogin} />
        ) : (
          <GameMenu token={token} studentId={studentId} onLogout={handleLogout} />
        )}
      </div>
    </div>
  );
}

export default App;
